import { render } from "./templates-list.vue?vue&type=template&id=6f9bc852"
import script from "./templates-list.vue?vue&type=script&lang=js"
export * from "./templates-list.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__